import React from 'react';
import classNames from 'classnames';
import { formatTime, formatDuration, getHumanDuration } from '../lib/timeFormat';

import styles from '../assets/css/offers.module.css';

const generateStopsLabel = (count) => {
  if (count === 1) return 'توقف واحد';
  if (count === 2) return 'توقفين';

  return `${count} توقف`;
};

const Segment = ({ origin, destination, departureDate, arrivalDate, stopsCount, stopsTime, durationInMinutes }) => (
  <>
    <div className={classNames(styles.offer_card_row, styles.details_main)}>
      <div className={styles.offer_card_col}>
        <p className={styles.date}>{formatTime(departureDate)}</p>
        <div>
          <p>{origin.iataCode}</p>
          <p>{origin.nameAr}</p>
        </div>
      </div>

      <div className={styles.offer_stops}>
        <span className="iconify card_arrow reverse" data-icon="fluent:airplane-24-filled"></span>
        <div>
          <p>{formatDuration(durationInMinutes)}</p>
          {!!stopsCount && <p>{generateStopsLabel(stopsCount)}</p>}
        </div>
      </div>

      <div className={styles.offer_card_col}>
        <p className={styles.date}>{formatTime(arrivalDate)}</p>
        <div>
          <p>{destination.iataCode}</p>
          <p>{destination.nameAr}</p>
        </div>
      </div>
    </div>
  </>
);

const Segments = ({ mode = 'compact', slice }) => {
  if (mode === 'compact') return <Segment
    {...slice}
    stopsCount={slice.segments.length - 1}
  // stopsDuration={slice}
  />;

  return (
    <>
      {
        slice.segments.map((segment, index) => {
          const nextSegment = slice.segments[index + 1];
          return (
            <>
              <div className={classNames(styles.details_main, styles.remove_highlight)}>
                <Segment
                  key={index}
                  {...segment}
                  stopsCount={segment.stops?.length}
                />

                <div className={classNames(styles.offer_card_col, styles.carrier_info)}>
                  <p>{segment.flightNumber}</p>
                  <p>{segment.airline.nameAr || segment.airline.nameEn}</p>
                </div>
              </div>

              {!!nextSegment?.departureDate && (
                <div className={styles.offer_details_separator}>
                  <p>{`توقف لمدة ${getHumanDuration(new Date(segment.arrivalDate), new Date(nextSegment.departureDate))} في ${segment.destination.nameAr}`}</p>
                </div>
              )}
            </>
          );
        })
      }
    </>
  );
};

export default Segments;